<template>
    <div class="ikea_home">
      <loading v-if="loading"/>
      <error/>
      <!-- 虛擬繳費機_01設定車牌 -->
      <section>
        <div class="container">
          <div class="row">
            <div class="col-lg-12 ikea-title text-center" v-if="brand == 'ikea'">
              IKEA 新店店
            </div>
            <div class="col-lg-12 ikea-title text-center" v-if="brand == 'ikea-taoyuan'">
              IKEA 桃園店
            </div>
            <div class="col-lg-12 ikea-subtitle text-center">
              線上停車繳費系統
            </div>
          </div>
          <div class="row">

              <div class="col-lg-12">
                <a v-on:click="webaps()">
                  <div class="ikea-box-pay">
                    <div class="fl">汽車停車繳費</div>
                    <div class="fr"><i class="fas fa-angle-right"></i></div>
                    <div class="cb"></div>
                  </div>
                </a>
              </div>
          
              <div class="col-lg-12">
                <a v-on:click="naviagtion()">
                  <div class="ikea-box-pay">
                    <div class="fl">導航至汽車停車場</div>
                    <div class="fr"><i class="fas fa-angle-right"></i></div>
                    <div class="cb"></div>
                  </div>
                </a>
              </div>

              <div class="col-lg-12" v-if="brand == 'ikea-taoyuan'">
                <a v-on:click="navigation_to_scooter()">
                  <div class="ikea-box-pay">
                    <div class="fl">導航至機車停車場</div>
                    <div class="fr"><i class="fas fa-angle-right"></i></div>
                    <div class="cb"></div>
                  </div>
                </a>
              </div>

              <div class="col-lg-12" v-if="emptyLotsAmounts.length == 0">
                <div class="ikea-box-lot">
                  <div class="fl">剩餘車位</div>
                  <transition name="fade" mode="out-in">
                    <div class="ikea-number-emptylot fr">
                      <div class="lds-dual-ring"></div>
                    </div>
                  </transition>
                  <div class="cb"></div>
                </div>
              </div>
              
              <div class="col-lg-12" v-for="emptyLotsAmount in emptyLotsAmounts" :key="emptyLotsAmount.name">
                <div class="ikea-box-lot" v-if="emptyLotsAmount.name != 'VIP區'">
                  <div class="fl">{{ emptyLotsAmount.name }}</div>
                  <transition name="fade" mode="out-in">
                    <div class="ikea-number-emptylot fr">{{ emptyLotsAmount.remain | thousandsSeparators }}</div>
                  </transition>
                  <div class="cb"></div>
                </div>
              </div>

              <div class="col-lg-12 ikea-box-useway">
                <!--<div class="ikea-text-useway">使用說明</div>-->
                <div class="ikea-content-payway">
                  <ul>
                    <li v-if="brand == 'ikea'">IKEA 新店店內之消費發票可折抵您的停車費用。</li>
                    <li v-if="brand == 'ikea-taoyuan'">IKEA 桃園店內之消費發票可折抵您的汽車停車費用。</li>
                    <li>可能需要您開啟相機授權，才能使用發票掃描折抵功能。</li>
                    <li>電子發票目前支援『捐贈發票』、『手機條碼載具』及『自然人憑證載具』設定。</li>
                    <li>若需開立『統一編號』發票，請至線下繳費機操作。</li>
                    <li>目前系統僅支援 LINE Pay 、 Apple Pay 支付。</li>
                  </ul>
                </div>
              </div>
            
              <!--
                <div class="col-lg-12 ikea-box-payway">
                <div class="ikea-text-payway">支付方式</div>
                <div class="ikea-content-payway">
                  <ul>
                    <li></li>
                    
                    <li>目前系統僅支援 LINE Pay 支付。</li>
                  </ul>
                </div>
              </div>
              -->

              

          </div>

        </div>
        <div class="ikea-hint">
          目前系統僅支援 LINE Pay、Apple Pay 支付
        </div>

        <div class="plate-modal modal fade" id="scan-error-modal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="close-modal" data-dismiss="modal" v-on:click="keepScan()">
                <div class="lr">
                  <div class="rl"></div>
                </div>
              </div>
              <div class="container">
                <div class="row">
                  <div class="col-lg-8 mx-auto">
                    <div class="modal-body">
                      <!-- Project Details Go Here -->
                      <br>
                      <h3>您的瀏覽器不支援掃描</h3>
                      <transition name="fade" mode="out-in">
                        <p key="1" class="item-intro text-muted" v-if="!showCopySuccess">
                          <span v-if="safari">
                            若需使用發票折抵功能，請 <br>
                            1. 使用 Safari 瀏覽器 <br>
                            2. 允許我們使用您的相機 <br>
                            如果您不是使用 Safari 瀏覽器，可以點選『複製連結』至 Safari 瀏覽器。 <br><br>
                            若您不需使用發票折抵，則無須理會此訊息。
                          </span>
                          <span v-if="android">
                            若需使用發票折抵功能，請 <br>
                            1. 使用 Chrome 瀏覽器 <br>
                            2. 允許我們使用您的相機 <br>
                            如果您不是使用 Chrome 瀏覽器，可以點選『複製連結』至 Chrome 瀏覽器。 <br><br>
                            若您不需使用發票折抵，則無須理會此訊息。
                          </span>
                        </p>
                        <div key="2" class="item-intro text-muted" v-if="showCopySuccess">
                          <p>複製成功！</p>
                            <div class="col-lg-12 tips-iphone" v-if="safari">
                                <p>請至<span>【Sarfari 瀏覽器】</span>將連結貼上網址列開啟網頁。</p>
                            </div>
                            <!-- ios 顯示以上 -->

                            <!-- android 顯示以下 -->
                            <div class="col-lg-12 tips-android" v-if="android">
                                <p>請至<span>【Chrome 瀏覽器】</span>將連結貼上網址列開啟網頁。</p>
                            </div>
                            <!-- android 顯示以上 -->
                        </div>

                      </transition>
                      <button class="btn btn-primary btn-frame" data-dismiss="modal" type="button" v-on:click="keepScan()">
                          不使用發票掃描，繼續繳費
                      </button>
                      <button v-if="brand == 'ikea'" class="btn btn-primary btn-green" id="copyLink" type="button" data-clipboard-text="https://ikea-xindian.parkit.vip/webaps">
                          複製連結至其他瀏覽器
                      </button>
                      <button v-if="brand == 'ikea-taoyuan'" class="btn btn-primary btn-green" id="copyLink" type="button" data-clipboard-text="https://ikea-taoyuan.parkit.vip/webaps">
                          複製連結至其他瀏覽器
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div><!-- modal-content ends -->
          </div><!-- modal-dialog ends -->
        </div>
        <!-- plate-delete-modal ends -->
      </section>
      <qrcode-stream class="qrcode" v-if="testScanner" @init="onInit" style="width:0%; height: 0%">
      </qrcode-stream>
    </div>
</template>


<script>
import ClipboardJS from 'clipboard';
import { QrcodeStream } from 'vue-qrcode-reader'

export default {
  name: 'SettingPlate',
  props: {
    msg: String
  },
  components: {
    QrcodeStream,
  },
  data() {
    return {
      loading: false,
      emptyLotsAmounts: [],
      testScanner: false,
      showCopySuccess: false,
      safari: false,
      android: false,
      brand: 'ikea'
    }
  },
  mounted() {
    var clipboard = new ClipboardJS('.btn')
    var self = this
    //self.loading = true
    clipboard.on('success', function(e) {
      self.showCopySuccess = true
      self.$ga.event('ikea-home', 'click', '複製連結繼續掃描')
    });
    self.brand = process.env.VUE_APP_BRAND
    self.getEmptyLots()
  },
  methods: {
    async onInit (promise) {
      var self = this
     try {
        await promise
        self.$router.push({ name: 'webaps' })
        self.$ga.event('ikea-home', 'click', '允許使用攝影機')
      } catch (error) {
        if(navigator.userAgent.indexOf("iPhone") >= 0){
            self.android = false
            self.safari = true
        }
        if (navigator.userAgent.indexOf("Android") >= 0) {
            self.android = true
            self.safari = false
        }
        $("#scan-error-modal").modal("show")
      } finally {
        self.$root.loading = false
        self.testScanner = false
      }
    },
    getEmptyLots: function() {
      var self = this
      if (this.brand == 'ikea') {
        self.$http.get('https://' + process.env.VUE_APP_API_URL + '/lots/remain_region_space?brands=' + process.env.VUE_APP_BRAND + "&lot_code=IKEA02001")
        .then((response) => {
          self.emptyLotsAmounts = response.body
          self.loading = false
        }).catch((err) => {
          self.loading = false
        })
      } else {
        self.$http.get('https://' + process.env.VUE_APP_API_URL + '/lots/remain_region_space?brands=' + process.env.VUE_APP_BRAND + "&lot_code=IKEA03001")
        .then((response) => {
          self.emptyLotsAmounts = response.body
          self.loading = false
        }).catch((err) => {
          self.loading = false
        })
      }
    },
    webaps: function() {
      var self = this
      self.testScanner = true
      self.$root.loading = true
      this.$ga.event('ikea-home', 'click', '停車繳費')
    },
    keepScan: function() {
      var self = this
      self.$router.push({ name: 'webaps' })
      self.$ga.event('ikea-home', 'click', '不掃描直接繳費')
    },
    naviagtion: function() {
      var self = this
      var win 
      if (this.brand == 'ikea') {
        win = window.open("https://www.google.com/maps/place/24%C2%B058'14.6%22N+121%C2%B031'58.3%22E/@24.9707352,121.5309892,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x0!8m2!3d24.970731!4d121.532864", '_blank');
      } else if (this.brand == 'ikea-taoyuan') {
        win = window.open("https://www.google.com/maps/place/25%C2%B000'44.9%22N+121%C2%B013'03.8%22E/@25.0124763,121.2155223,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x0!8m2!3d25.0124715!4d121.217711", '_blank');
      }
      self.$ga.event('ikea-home', 'click', '導航至停車場')
      win.focus();
    },
    navigation_to_scooter: function() {
      var self = this
      var win 
      if (this.brand == 'ikea') {
        win = window.open("https://www.google.com/maps/place/24%C2%B058'14.6%22N+121%C2%B031'58.3%22E/@24.9707352,121.5309892,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x0!8m2!3d24.970731!4d121.532864", '_blank');
      } else if (this.brand == 'ikea-taoyuan') {
        win = window.open("https://www.google.com/maps/place/25%C2%B000'48.4%22N+121%C2%B013'04.1%22E/@25.0134428,121.2156243,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x0!8m2!3d25.013438!4d121.217813", '_blank');
      }
      self.$ga.event('ikea-home', 'click', '導航至停車場')
      win.focus();
    }
  }
}
</script>